module.exports = __webpack_public_path__ + "static/media/btn-image-1.8f7e0ddb.png";